import type { ReactNode } from "react";

interface SkeletonProps {
  className?: string;
}

export const Skeleton = ({ className = "" }: SkeletonProps) => (
  <span aria-hidden="true" className={`skeleton block ${className}`} />
);

interface SkeletonRegionProps {
  visible: boolean;
  label?: string;
  className?: string;
  children: ReactNode;
}

export const SkeletonRegion = ({
  visible,
  label = "Chargement en cours",
  className = "",
  children,
}: SkeletonRegionProps) => (
  <div
    role="status"
    aria-busy="true"
    aria-live="polite"
    className={`transition-opacity duration-200 motion-reduce:transition-none ${
      visible ? "opacity-100" : "opacity-0"
    } ${className}`}
  >
    <span className="sr-only">{label}</span>
    <div aria-hidden="true" className="contents">
      {children}
    </div>
  </div>
);
